"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ウインドウ等総合管理クラス
 *
 * @export
 * @class Jwf
 */
var Manager = /** @class */ (function () {
    function Manager() {
    }
    /**
     * マウスとタッチイベントの座標取得処理
     * @param  {MouseEvent|TouchEvent} e
     * @returns {Point} マウスの座標
     */
    Manager.getPos = function (e) {
        var p;
        if (e.targetTouches &&
            e.targetTouches.length) {
            var touch = e.targetTouches[0];
            p = { x: touch.pageX, y: touch.pageY };
        }
        else {
            p = { x: e.clientX, y: e.clientY };
        }
        return p;
    };
    /**
     * ノードに対してイベントを発生させる
     *
     * @static
     * @param {HTMLElement} node 対象ノード
     * @param {string} ename イベント名
     * @param {*} [params] イベント発生時にevent.paramsの形で送られる
     * @memberof Jwf
     */
    Manager.callEvent = function (node, ename, params) {
        node.dispatchEvent(Manager.createEvent(ename, params));
    };
    /**
     *イベントを作成する
     *
     * @static
     * @param {string} ename イベント名
     * @param {*} [params] イベント発生時にevent.paramsの形で送られる
     * @returns {Event} 作成したイベント
     * @memberof Jwf
     */
    Manager.createEvent = function (ename, params) {
        var event;
        try {
            event = new CustomEvent(ename);
        }
        catch (e) {
            event = document.createEvent("CustomEvent");
            event.initCustomEvent(ename, false, false, null);
        }
        if (params) {
            event.params = params;
        }
        return event;
    };
    /**
     *ノードを作成する
     *
     * @static
     * @param {string} tagName タグ名
     * @param {*} [params] タグパラメータ
     * @returns {HTMLElement} 作成したノード
     * @memberof Jwf
     */
    Manager.createElement = function (tagName, params) {
        var tag = document.createElement(tagName);
        if (params) {
            for (var index in params) {
                var p = params[index];
                if (typeof p === "object" && p) {
                    for (var _i = 0, _a = Object.keys(p); _i < _a.length; _i++) {
                        var index2 = _a[_i];
                        tag[index][index2] =
                            p[index2];
                    }
                }
                else {
                    tag[index] = p;
                }
            }
        }
        return tag;
    };
    Manager.init = function () {
        if (window && !this.initFlag) {
            this.initFlag = true;
            window.addEventListener("mouseup", mouseUp, false);
            window.addEventListener("touchend", mouseUp, { passive: false });
            window.addEventListener("mousemove", mouseMove, false);
            window.addEventListener("touchmove", mouseMove, { passive: false });
            window.addEventListener("touchstart", onTouchStart, { passive: false });
        }
    };
    Manager.moveNode = null;
    Manager.frame = null;
    Manager.initFlag = false;
    return Manager;
}());
exports.Manager = Manager;
// マウスが離された場合に選択をリセット
function mouseUp() {
    Manager.moveNode = null;
    Manager.frame = null;
}
// マウス移動時の処理
function mouseMove(e) {
    if (Manager.moveNode) {
        if ("touches" in e && e.touches.length === 2) {
            if (Manager.pinchiBaseDistance === undefined) {
                Manager.pinchiBaseDistance = getDistance(e.touches);
            }
            else {
                var node = Manager.moveNode; // 移動中ノード
                var p = Manager.getPos(e); // 座標の取得
                var distance = getDistance(e.touches) - Manager.pinchiBaseDistance;
                var radian = getRadian(e.touches);
                var params = {
                    event: e,
                    nodePoint: { x: Manager.nodeX, y: Manager.nodeY },
                    basePoint: { x: Manager.baseX, y: Manager.baseY },
                    nowPoint: { x: p.x, y: p.y },
                    nodeSize: { width: Manager.nodeWidth, height: Manager.nodeHeight },
                    distance: distance,
                    radian: radian
                };
                Manager.callEvent(node, "move", params);
            }
            e.preventDefault();
            // e.stopPropagation();
        }
        else {
            var node = Manager.moveNode; // 移動中ノード
            var p = Manager.getPos(e); // 座標の取得
            var params = {
                event: e,
                nodePoint: { x: Manager.nodeX, y: Manager.nodeY },
                basePoint: { x: Manager.baseX, y: Manager.baseY },
                nowPoint: { x: p.x, y: p.y },
                nodeSize: { width: Manager.nodeWidth, height: Manager.nodeHeight }
            };
            Manager.callEvent(node, "move", params);
            e.preventDefault();
            // e.stopPropagation();
        }
    }
    // e.preventDefault();
}
function getDistance(p) {
    var x = p[0].pageX - p[1].pageX;
    var y = p[0].pageY - p[1].pageY;
    return Math.sqrt(x * x + y * y);
}
function getRadian(p) {
    var x = p[0].pageX - p[1].pageX;
    var y = p[0].pageY - p[1].pageY;
    return Math.atan2(y, x);
}
function onTouchStart(e) {
    Manager.pinchiBaseDistance = undefined;
}
//# sourceMappingURL=index.js.map